<div *ngIf="form" editorType="medium">
  <form [formGroup]="form">
    <div class="column">
      <dx-lookup
        formControlName="plantId"
        formField
        required
        [label]="'common.tabTitle.plant' | translate | ucfirst"
        [gsResource]="plantsResource"
        displayExpr="name"
        valueExpr="id"
      />
      <dx-lookup
        formControlName="sectionId"
        formField
        [label]="'common.tabTitle.section' | translate | ucfirst"
        [gsResource]="sectionsResource"
        displayExpr="name"
        valueExpr="id"
        [backendFilters]="{ plantId: form.controls['plantId'].value ?? EMPTY_TID }"
        [disabled]="form.controls['plantId'].value === null || form.controls['plantId'].value === undefined || form.controls['plantId'].value === ''"
      />
      <dx-lookup
        formControlName="workCenterId"
        formField
        [label]="'common.tabTitle.workcenter' | translate | ucfirst"
        [gsResource]="workcentersResource"
        displayExpr="name"
        valueExpr="id"
        [backendFilters]="{ sectionId: form.controls['sectionId'].value ?? EMPTY_TID }"
        [disabled]="(form.controls['plantId'].value === null || form.controls['plantId'].value === undefined || form.controls['plantId'].value === '') || (form.controls['sectionId'].value === null || form.controls['sectionId'].value === undefined || form.controls['sectionId'].value === '')"
      />
      <dx-text-area
        formControlName="description"
        formField
        required
        [label]="'entity.overhead.description' | translate | ucfirst"
      />
      <dx-lookup
        formControlName="formatId"
        formField
        required
        [label]="'entity.overhead.formatId' | translate | ucfirst"
        [gsResource]="formatsResource"
        displayExpr="name"
        valueExpr="id"
      />
    </div>
  </form>

  <div class="controls">
    <dx-tab-panel>
      <dxi-item [title]="'common.costs' | translate | ucfirst">
        <dx-data-grid
          *ngIf="overheadCostsResource"
          [glamResource]="overheadCostsResource"
          [createComponent]="overheadCostsAddComponent"
          [customParams]="{ overheadId: form.controls['id'].value }"
          (onSaved)="onOverheadCostsSaved()"
          (entityCreated)="onOverheadCostsSaved()"
          (entityDeleted)="onOverheadCostsSaved()"
          (onRowUpdated)="onOverheadCostsSaved()"
        >
          <dxi-column dataField="date" dataType="date" [caption]="'common.date' | translate | ucfirst" sortOrder="desc" sortIndex="0"></dxi-column>
          <dxi-column gsCurrencyColumn dataField="cost" dataType="number" digitsInfo="1.0-20" [caption]="'common.cost' | translate | ucfirst"></dxi-column>
        </dx-data-grid>
      </dxi-item>
    </dx-tab-panel>
  </div>
</div>
